<template>
	<div class="floorplan">
		<div class="bg"></div>

		<img src="../assets/alaprajzok2.jpg" usemap="#image-map">

		<map name="image-map" id="image-map">
		    <area target="" alt="" title="" href="#" coords="96,501,207,573" shape="rect" v-on:click="areaSelected($event, 1)">
		    <area target="" alt="" title="" href="#" coords="260,480,348,551" shape="0" v-on:click="areaSelected($event, 2)">
		    <area target="" alt="" title="" href="#" coords="353,481,440,547" shape="0" v-on:click="areaSelected($event, 3)">
		    <area target="" alt="" title="" href="#" coords="416,208,485,357" shape="0" v-on:click="areaSelected($event, 4)">
		    <area target="" alt="" title="" href="#" coords="492,184,556,246" shape="0" v-on:click="areaSelected($event, 5)">
		    <area target="" alt="" title="" href="#" coords="556,317,490,258" shape="0" v-on:click="areaSelected($event, 6)">
		    <area target="" alt="" title="" href="#" coords="492,330,556,394" shape="0" v-on:click="areaSelected($event, 7)">
		    <area target="" alt="" title="" href="#" coords="629,179,703,242" shape="0" v-on:click="areaSelected($event, 8)">
		    <area target="" alt="" title="" href="#" coords="622,258,701,319" shape="0" v-on:click="areaSelected($event, 9)">
		    <area target="" alt="" title="" href="#" coords="622,328,701,391" shape="0" v-on:click="areaSelected($event, 10)">
		    <area target="" alt="" title="" href="#" coords="704,486,735,552" shape="0" v-on:click="areaSelected($event, 12)">
		    <area target="" alt="" title="" href="#" coords="994,430,1023,491" shape="0" v-on:click="areaSelected($event, 13)">
		    <area target="" alt="" title="" href="#" coords="1111,308,1165,349" shape="0" v-on:click="areaSelected($event, 16)">
		    <area target="" alt="" title="" href="#" coords="1327,200,1440,333" shape="0" v-on:click="areaSelected($event, 18)">
		    <area target="" alt="" title="" href="#" coords="1240,375,1325,459" shape="0" v-on:click="areaSelected($event, 19)">
		    <area target="" alt="" title="" href="#" coords="1457,308,1523,351" shape="0" v-on:click="areaSelected($event, 20)">
		    <area target="" alt="" title="" href="#" coords="1623,423,1683,454" shape="0" v-on:click="areaSelected($event, 22)">
		    <area target="" alt="" title="" href="#" coords="1361,399,1428,441" shape="0" v-on:click="areaSelected($event, 23)">
		    <area target="" alt="" title="" href="#" coords="1034,741,1166,816" shape="0" v-on:click="areaSelected($event, 24)">
		    <area target="" alt="" title="" href="#" coords="1173,741,1247,818" shape="0" v-on:click="areaSelected($event, 25)">
		    <area target="" alt="" title="" href="#" coords="1255,742,1330,815" shape="0" v-on:click="areaSelected($event, 26)">
		    <area target="" alt="" title="" href="#" coords="1346,737,1433,820" shape="0" v-on:click="areaSelected($event, 27)">
		    <area target="" alt="" title="" href="#" coords="1082,855,1166,916" shape="0" v-on:click="areaSelected($event, 28)">
		    <area target="" alt="" title="" href="#" coords="1176,850,1232,919" shape="0" v-on:click="areaSelected($event, 29)">
		    <area target="" alt="" title="" href="#" coords="1276,852,1332,924" shape="0" v-on:click="areaSelected($event, 30)">
		    <area target="" alt="" title="" href="#" coords="1345,850,1396,921" shape="0" v-on:click="areaSelected($event, 31)">
		    <area target="" alt="" title="" href="#" coords="1503,908,1586,989" shape="0" v-on:click="areaSelected($event, 32)">
		    <area target="" alt="" title="" href="#" coords="1588,910,1668,987" shape="0" v-on:click="areaSelected($event, 33)">
		    <area target="" alt="" title="" href="#" coords="1673,908,1733,985" shape="0" v-on:click="areaSelected($event, 34)">
		    <area target="" alt="" title="" href="#" coords="279,1127,348,1175" shape="0" v-on:click="areaSelected($event, 35)">
		    <area target="" alt="" title="" href="#" coords="421,1029,489,1077" shape="0" v-on:click="areaSelected($event, 36)">
		</map>

		<!--<div class="picker-wrapper">
			<a :href="links[pickerIndex]"><span class="picker-button">Kiállító weboldalának megtekintése</span></a>
			<smooth-picker ref="smoothPicker" :data="data" :change="pickerChange" />
		</div>-->

		<div class="tooltip" id="tooltip">
			<div v-if="selectedSponsor">
				{{ selectedSponsor.company }}
				<a :href="selectedSponsor.website"><span class="picker-button">Weboldal megnyitása</span></a>
			</div>
			<div v-else>
				Nincs kiállító
			</div>
			<i class="arrow down"></i>
		</div>
	</div>
</template>

<script>
	export default {
		data () {
			return {
				sponsors: [
				{
					"booths": [19, 20, 22],
					"company": "Raynet Kft.",
					"website": "http://raynet.hu"
				},
				{
					"booths": [16],
					"company": "EL-CO Tech Kft.",
					"website": "http://elocotech.hu"
				},
				{
					"booths": [5],
					"company": "Hauff-Technik Hungária Kft.",
					"website": "http://hauff-technik.hu"
				},
				{
					"booths": [18],
					"company": "Megawatt Mérnökiroda Kft.",
					"website": "http://mwmi.hu"
				},
				{
					"booths": [4],
					"company": "Maxicont Kft. / Megger Hungária Kft.",
					"website": "http://maxicont.hu"
				},
				{
					"booths": [26],
					"company": "Weidmüller Kft.",
					"website": "http://weidmueller.com"
				},
				{
					"booths": [28],
					"company": "TE Connectivity",
					"website": "http://te.com"
				},
				{
					"booths": [6],
					"company": "Omexom Magyarország Kft.",
					"website": "http://omexom.hu"
				},
				{
					"booths": [30],
					"company": "HOFEKA Kft.",
					"website": "http://hofeka.hu"
				},
				{
					"booths": [13],
					"company": "Enersys Kft.",
					"website": "http://enersys.com"
				},
				{
					"booths": [27],
					"company": "Prolan Innolab Kft.",
					"website": "http://prolaninnolab.hu"
				},
				{
					"booths": [31],
					"company": "PHOENIX CONTACT Kft.",
					"website": "http://phoenixcontact.com"
				},
				{
					"booths": [2, 3],
					"company": "Ganz Mérőgyár Kft.",
					"website": "http://itron.com"
				},
				{
					"booths": [29],
					"company": "Ekofluid sro",
					"website": "http://ekofluid.com"
				},
				{
					"booths": [12],
					"company": "FirePro Hungary Kft.",
					"website": "http://firepro.hu"
				},
				{
					"booths": [24],
					"company": "Villbek Kft.",
					"website": "http://villbek.hu"
				},
				{
					"booths": [7],
					"company": "C+D Automatika Kft.",
					"website": "http://meter.hu"
				},
				{
					"booths": [25],
					"company": "WAGO Hungária Kft.",
					"website": "http://wago.com"
				},
				{
					"booths": [32, 33, 34],
					"company": "Geometria Kft.",
					"website": "http://geometria.hu"
				},
				{
					"booths": [1],
					"company": "Diagnostics Kft.",
					"website": "http://diagnostics.hu"
				},
				{
					"booths": [8, 9, 10],
					"company": "Marchiol Kft.",
					"website": "http://marchiol.hu"
				},
				{
					"booths": [35],
					"company": "Technikatörténeti Bizottság",
					"website": "http://www.mee.hu/ttb"
				},
				{
					"booths": [23],
					"company": "Hensel Hungária Kft.",
					"website": "http://www.hensel.hu"
				},
				{
					"booths": [36],
					"company": "Better és Better Bt",
					"website": "http://betterbt.hu/"
				}
				],
				selectedSponsor: undefined
			}
		},
		methods: {
			areaSelected($event, index){
				event.preventDefault();
				this.selectedSponsor = undefined;
				for(var sponsor of this.sponsors){
					if(sponsor.booths.includes(index)){
						this.selectedSponsor = sponsor;
						break;
					}
				}

				this.pickerIndex = index - 1;
				console.log(event.target.coords.split(','));
				let mapRect = document.getElementById("image-map").getBoundingClientRect();
				let coords = event.target.coords.split(',');
				let x1 = parseInt(coords[0]);
				let y1 = parseInt(coords[1]);
				let x2 = parseInt(coords[2]);
				let y2 = parseInt(coords[3]);

				console.log(mapRect);
				let tooltip = document.getElementById("tooltip");

				let middleX = (x1 + x2) / 2;
				let middleY = (y1 + y2) / 2;

				tooltip.style.left = middleX + 'px';
				tooltip.style.top = middleY +'px';
				tooltip.style.opacity = 1;
	    		//this.$refs.smoothPicker.currentIndexList[0] = index - 1;
	    		//this.$refs.smoothPicker.correctionCurrentIndex(null, 0);
	    		const rect = event.target.getBoundingClientRect();
	    		console.log(rect.left + window.scrollX);
	    		console.log(rect.top + window.scrollY);
	    	}
	    },
	    created () {
	    	console.log("appId", this.$route.params.appId);
	    },
	    mounted(){
	    	console.log("asd", imageMapResize());
	    }
	}
</script>

<style scoped>
/* 
.floorplan img{
	width: 100%;
	margin-bottom: 200px;
}
*/
.bg{
	background-color: white;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: -100;
}
.picker-wrapper{
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 200px;
	background-color: #fff;
	border: 1px solid #eee;
}
.picker-button{
	margin: 8px;
	display: block;
}
.tooltip{
	font-size: 8pt;
	background-color: #eee;
	border-radius: 8px;
	width: 100px;
	position: absolute;
	top: 0;
	left: 0;
	transform: translate(-50%, -50%);
	opacity: 0;
}

i {
	border: solid #eee;
	border-width: 0 6px 6px 0;
	display: inline-block;
	padding: 6px;
}
.down {
	transform: rotate(45deg);
	-webkit-transform: rotate(45deg);
	margin-bottom: -8px;
}
</style>


// WEBPACK FOOTER //
// floorplan.vue?297c5608